<template>
    <div class="coupon-voucher-card"
        :class="{ 
            'my-coupon-card': isMyList && item.type === 1 && !item.isDisabled, 
            'my-voucher-card': isMyList && item.type === 2  && !item.isDisabled,
            'disabled-card': item.isDisabled
        }">
        <div class="d-flex justify-content-between">
            <div>
                <div><strong>{{ item.type === 1 ? "Coupon" : "Voucher" }}</strong></div>
                <div style="font-size: 90%;">{{item.description}}</div>
                <div v-if="item.isVoucher" style="font-size: 90%;">Price: {{item.price}} iR</div>
                <div v-if="!item.isVoucher" style="font-size: 90%;">Status: {{item.statusText}}</div>
                <div v-if="!item.isVoucher" style="font-size: 90%;">Usage: {{item.usageText}}</div>
                <div v-if="item.isVoucher && !isMyList" style="font-size: 90%;">Validity: {{item.validityText}}</div>
                <div v-if="item.isVoucher && isMyList" style="font-size: 90%;">Validity: {{item.myValidityText}}</div>
            </div>
            <div class="text-right">
                <h5 class="mb-0"><strong>{{item.bonusAmount}}</strong>{{ item.bonusUnit }}</h5>
                <div style="font-size: 90%;">{{ item.type === 1 ? "&nbsp;" : "Voucher bonus" }}</div>
                <div class="mt-1">
                    <button class="button-get-use" :disabled="item.isDisabled"
                        @click="onButtonTrigger">
                        {{ isMyList && item.isExpired ? "Expired" : "" }}
                        {{ isMyList && item.isUsed ? "Used" : "" }}
                        {{ !item.isDisabled && isMyList ? "Use now" : "" }}
                        {{ !isMyList ? "Get now" : "" }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        isMyList: {
            type: Boolean,
            default: () => false
        },
        buttonTrigger: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        onButtonTrigger() {
            this.buttonTrigger(this.item);
        }
    }
}
</script>